import React, { useContext, useEffect, useState } from "react";
import { Elements } from "@stripe/react-stripe-js";
import { useParams } from "react-router-dom";
import { AuthContext } from "../../contexts/AuthProvider";
import StripeForm from "./StripeForm";
import { loadStripe } from "@stripe/stripe-js";
import axios from "axios";
import logo from "./../../assest/logo-my-color-event.png";
import jsPDF from "jspdf";
import "jspdf-autotable";
import noImage from "./../../assest/icon/no-image.png";
import deliveryTruck from "./../../assest/icon/delivery-truck1.png";
import PoppinsRegular from "./../../assest/font/Poppins-Regular.ttf"; // Path to your font file
import PoppinsBold from "./../../assest/font/Poppins-Bold.ttf"; // Path to your font file

const EventPayment = () => {
  const { id } = useParams(); // Get the 'id' from route params
  const [products, setProducts] = useState(null); // State for real-time product data
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const allSet = products?.set || [];
  const orderId = products?._id;
  const personEmail = products?.email;

  const [paymentData, setPaymentData] = useState([]);
  const [totalPayAmount, setTotalPayAmount] = useState(0);

  const invoicePaymentId = products?.paymentId;

  useEffect(() => {
    if (personEmail && invoicePaymentId) {
      const fetchPaymentData = async () => {
        try {
          const response = await axios.get(
            `https://server-gs.vercel.app/paid/stripe/${personEmail}/${invoicePaymentId}`
          );
          setPaymentData(response.data);

          // Calculate the total payAmount if available
          const total = response.data.reduce(
            (acc, payment) => acc + (parseFloat(payment.payAmount) || 0),
            0
          );
          setTotalPayAmount(total?.toFixed(2)); // Ensure two decimal places
        } catch (err) {
          console.error("Error fetching payment data:", err);
          setError("Failed to fetch payment data");
        }
      };

      fetchPaymentData();
    }
  }, [personEmail, invoicePaymentId]);

  // const stripePromise = loadStripe(
  //   "pk_test_51M95efHKtD2PGvOuiKU700FfXCTPrQ3080hQT7DTNIT0t43MvJL3YqoLLpvNz4C4KwzN3E9V3SDDdIzubSACERWG00482N2iu5"
  // );

    const stripePromise = loadStripe(
    "pk_live_72A5EXf3VufSNIajFdUQ6aae"
  );

  useEffect(() => {
    if (personEmail) {
      const fetchPaymentData = async () => {
        try {
          const response = await axios.get(
            `https://server-gs.vercel.app/paid/stripe/${personEmail}`
          );
          setPaymentData(response.data);

          // Calculate the total payAmount if available
          const total = response.data.reduce(
            (acc, payment) => acc + (parseFloat(payment.payAmount) || 0),
            0
          );
          setTotalPayAmount(total.toFixed(2)); // Ensure two decimal places
        } catch (err) {
          console.error("Error fetching payment data:", err);
          setError("Failed to fetch payment data");
        }
      };

      fetchPaymentData();
    }
  }, [personEmail]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(
          "https://server-gs.vercel.app/event-company-profile"
        );
        setData(response.data);
        setError(null); // Clear any previous errors
      } catch (err) {
        setError(err.message || "Something went wrong");
      } finally {
        // setLoading(false);
      }
    };

    // Fetch data every second
    const intervalId = setInterval(fetchData, 1000);

    // Cleanup the interval on component unmount
    return () => clearInterval(intervalId);
  }, []);

  // Function to fetch product details
  const fetchProductDetails = async () => {
    try {
      const response = await fetch(
        `https://server-gs.vercel.app/admin/orders/${id}`
      );
      const data = await response.json();
      setProducts(data);
      setLoading(false);
    } catch (error) {
      console.error("Error fetching product details:", error);
    }
  };

  useEffect(() => {
    fetchProductDetails(); // Initial fetch

    // Polling every 5 seconds
    const interval = setInterval(() => {
      fetchProductDetails();
    }, 1000);

    return () => clearInterval(interval); // Cleanup interval on unmount
  }, [id]);

  const calculateTotalPrice = (pro) => {
    let priceAfterDiscount = pro.selectedPricingValue;

    // Apply discount to the selectedPricingValue first
    if (pro?.discount) {
      const discountValue =
        pro.discountType === "%"
          ? (parseFloat(pro.discount) / 100) * priceAfterDiscount
          : parseFloat(pro.discount);

      priceAfterDiscount -= discountValue;
    }

    // Multiply the discounted price by the quantity
    let total = pro.quantity * priceAfterDiscount;

    // Add tax after applying discount and calculating the total
    if (pro?.tax) {
      const taxValue = (parseFloat(pro.tax) / 100) * total;
      total += taxValue;
    }

    // Ensure total is not negative
    return Math.max(0, total).toFixed(2);
  };

  const calculateSubTotalPrice = (pro) => {
    return pro.quantity * pro.selectedPricingValue;
  };

  const calculateSetSubTotal = (products) => {
    return products
      .reduce((acc, pro) => acc + calculateSubTotalPrice(pro), 0)
      .toFixed(2);
  };

  const calculateSetTotal = (products) => {
    return products
      .reduce((acc, pro) => acc + parseFloat(calculateTotalPrice(pro)), 0)
      .toFixed(2);
  };

  const calculateDiscountTotal = (products) => {
    return products
      .reduce((acc, pro) => {
        if (pro?.discount) {
          let discountValue = 0;

          if (pro.discountType === "%") {
            // For percentage discount, calculate based on the subtotal
            const subtotal = pro.quantity * pro.selectedPricingValue;
            discountValue = (parseFloat(pro.discount) / 100) * subtotal;
          } else if (pro.discountType === "$") {
            // For fixed amount discount, apply the discount directly (do not multiply by quantity)
            discountValue = parseFloat(pro.discount);
          }

          acc += discountValue; // Accumulate the discount value
        }
        return acc;
      }, 0)
      .toFixed(2); // Return the total discount rounded to 2 decimal places
  };

  // Function to calculate total tax
  const calculateTaxTotal = (products) => {
    return products
      .reduce((totalTax, product) => {
        // Get base price or default to 0
        const price = parseFloat(product.selectedPricingValue) || 0;
        const quantity = parseInt(product.quantity) || 1;

        // Apply discount if exists
        let priceAfterDiscount = price;
        if (product?.discount) {
          const discountAmount = parseFloat(product.discount) || 0;
          const discountValue =
            product.discountType === "%"
              ? (discountAmount / 100) * priceAfterDiscount
              : discountAmount;
          priceAfterDiscount = Math.max(0, priceAfterDiscount - discountValue);
        }

        // Calculate subtotal after discount
        const subtotal = quantity * priceAfterDiscount;

        // Calculate tax for this product if tax exists
        const productTax = product?.tax
          ? (parseFloat(product.tax) / 100) * subtotal
          : 0;

        return totalTax + productTax;
      }, 0)
      .toFixed(2);
  };

  const calculateAllSetSubTotal = (allSet) => {
    return allSet
      .reduce((total, perSet) => {
        // Calculate the subtotal for each set, using the correct array of products
        const setTotal = parseFloat(calculateSetSubTotal(perSet.products)); // Fix here
        return total + setTotal;
      }, 0)
      .toFixed(2);
  };

  const calculateAllSetTotal = (allSet) => {
    return allSet
      .reduce((total, perSet) => {
        const setTotal = perSet.products.reduce(
          (acc, pro) => acc + parseFloat(calculateTotalPrice(pro)),
          0
        );
        return total + setTotal;
      }, 0)
      .toFixed(2);
  };

  const calculateProductDiscountPrice = (pro) => {
    const totalWithoutDiscount = parseFloat(calculateSingleTotalPrice(pro));
    const totalWithDiscount = parseFloat(calculateWithDiscountPrice(pro));

    // Calculate the difference
    const discountAmount = totalWithoutDiscount - totalWithDiscount;

    // Ensure the discount amount is not negative
    return Math.max(0, discountAmount).toFixed(2);
  };

  const calculateAllSetDiscount = (allSet) => {
    return allSet
      .reduce((total, perSet) => {
        const setDiscount = perSet.products.reduce((acc, pro) => {
          return acc + parseFloat(calculateProductDiscountPrice(pro));
        }, 0);

        return total + setDiscount;
      }, 0)
      .toFixed(2); // Round to 2 decimal places
  };

  // Function to calculate All Set Tax
  const calculateAllSetTax = (allSet) => {
    return allSet
      .reduce((totalSetsTax, perSet) => {
        // Calculate tax for all products in this set
        const setTax = perSet.products.reduce(
          (productTaxAccumulator, product) => {
            // Get base price or default to 0
            const price = parseFloat(product.selectedPricingValue) || 0;
            const quantity = parseInt(product.quantity) || 1;

            // Apply discount if exists
            let priceAfterDiscount = price;
            if (product?.discount) {
              const discountAmount = parseFloat(product.discount) || 0;
              const discountValue =
                product.discountType === "%"
                  ? (discountAmount / 100) * priceAfterDiscount
                  : discountAmount;
              priceAfterDiscount = Math.max(
                0,
                priceAfterDiscount - discountValue
              );
            }

            // Calculate subtotal after discount
            const subtotal = quantity * priceAfterDiscount;

            // Calculate tax for this product if tax exists
            return (
              productTaxAccumulator +
              (product?.tax ? (parseFloat(product.tax) / 100) * subtotal : 0)
            );
          },
          0
        );

        return totalSetsTax + setTax;
      }, 0)
      .toFixed(2); // Total tax for all sets
  };

  const calculateFinalTotal = (allSet, products) => {
    // Calculate the total for all sets
    const total = calculateAllSetTotal(allSet);

    // Get the discount value and type
    const discount = parseFloat(products?.AllProductDiscount) || 0;
    const discountType = products?.AllProductDiscountType;

    let finalTotal = parseFloat(total);

    // Apply discount based on the discount type
    if (discountType === "$") {
      // Subtract fixed amount discount
      finalTotal -= discount;
    } else if (discountType === "%") {
      // Subtract percentage discount
      finalTotal -= (discount / 100) * finalTotal;
    }

    // Ensure the final total is not negative
    return Math.max(0, finalTotal).toFixed(2);
  };

  const calculateDeposit = (
    finalTotal,
    advanceDepositValue,
    advanceDepositType
  ) => {
    if (!advanceDepositValue || !advanceDepositType || isNaN(finalTotal)) {
      return "0.00"; // Default to 0 if inputs are invalid
    }

    let depositAmount = 0;

    if (advanceDepositType === "%") {
      // If the deposit type is percentage, calculate based on finalTotal
      depositAmount =
        (parseFloat(advanceDepositValue) / 100) * parseFloat(finalTotal);
    } else if (advanceDepositType === "$") {
      // If the deposit type is fixed dollar amount, use the given value
      depositAmount = parseFloat(advanceDepositValue);
    }

    // Ensure depositAmount is not negative and format it to 2 decimal places
    return Math.max(0, depositAmount).toFixed(2);
  };

  const calculateAmountDue = (allSet, products, totalPayAmount) => {
    const finalTotal = parseFloat(calculateFinalTotal(allSet, products)); // Call the function
    return (finalTotal - totalPayAmount).toFixed(2); // Subtract totalPayAmount
  };

  const amountDue = calculateAmountDue(allSet, products, totalPayAmount);

  const calculatePayFinalAmount = (allSet, products, totalPayAmount) => {
    // Calculate the amount due
    const amountDue = calculateAmountDue(allSet, products, totalPayAmount);

    // Check if advanceDepositValue is available
    if (products?.advanceDepositValue) {
      // Calculate the deposit
      const deposit = calculateDeposit(
        calculateFinalTotal(allSet, products), // Final total
        products.advanceDepositValue, // Advance deposit value
        products.advanceDepositType // Advance deposit type
      );

      if (!products?.paidStripeAmount) {
        return deposit;
      }

      // Compare the calculated deposit with products?.paidStripeAmount
      if (parseFloat(deposit) === parseFloat(products?.paidStripeAmount)) {
        return amountDue; // Return the amount due if they match
      }
    }

    // If advanceDepositValue is not available or deposit doesn't match, return amountDue
    return amountDue;
  };

  // Example Usage
  const payFinalAmount = calculatePayFinalAmount(
    allSet,
    products,
    totalPayAmount
  );

  const calculateWithDiscountPrice = (pro) => {
    let priceAfterDiscount = pro.selectedPricingValue;

    // Apply discount to the selectedPricingValue first
    if (pro?.discount) {
      const discountValue =
        pro.discountType === "%"
          ? (parseFloat(pro.discount) / 100) * priceAfterDiscount
          : parseFloat(pro.discount);

      priceAfterDiscount -= discountValue;
    }

    // Multiply the discounted price by the quantity
    let total = pro.quantity * priceAfterDiscount;

    // Ensure total is not negative
    return Math.max(0, total).toFixed(2);
  };

  const calculateSingleTotalPrice = (pro) => {
    if (!pro || typeof pro !== "object") return "0.00";

    const quantity = Number(pro.quantity) || 0;
    const price = Number(pro.selectedPricingValue) || 0;

    const total = quantity * price;

    return total > 0 ? total.toFixed(2) : "0.00";
  };

  const calculateDiscountSelectedPrice = (pro) => {
    let price = pro?.selectedPricingValue;

    // Apply discount first
    if (pro?.discount) {
      const discountValue =
        pro?.discountType === "%"
          ? (parseFloat(pro?.discount) / 100) * price
          : parseFloat(pro?.discount);

      price -= discountValue;
    }

    // Ensure total is not negative
    return Math.max(0, price).toFixed(2);
  };

  const [data, setData] = useState(null);
  const [selectedOption, setSelectedOption] = useState("");

  const dataTermsConditions = products?.termsConditions;

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(
          "https://server-gs.vercel.app/event-company-profile"
        );
        setData(response.data);
        setError(null); // Clear any previous errors

        // Only set the default option if the user hasn't manually selected an option
        if (response.data) {
          const matchedField = Object.keys(response.data).find(
            (key) => key === dataTermsConditions
          );

          // If a match is found, set the matched field as the default
          if (matchedField) {
            setSelectedOption(matchedField);
          }
        }
      } catch (err) {
        setError(err.message || "Something went wrong");
      } finally {
        setLoading(false);
      }
    };

    // Fetch data every second
    const intervalId = setInterval(fetchData, 1000);

    // Cleanup the interval on component unmount
    return () => clearInterval(intervalId);
  }, [dataTermsConditions]); // Add isUserSelected as a dependency

  const renderSelectedContent = () => {
    if (!data) return null;

    // If selectedOption matches a field in data, return its value
    if (selectedOption && data[selectedOption]) {
      return data[selectedOption];
    }

    // If dataTermsConditions matches a field in data, return its value as default
    if (dataTermsConditions && data[dataTermsConditions]) {
      return data[dataTermsConditions];
    }

    // Fallback if no match is found
    return "Please select an option.";
  };



  const [isLoading, setIsLoading] = useState(false);

  const updatePaymentInBackend = async () => {
    if (!orderId) return;

    setIsLoading(true);
    setError(null);

    try {
      const totalAmount = calculateFinalTotal(allSet, products);
      const amountDue = calculateAmountDue(allSet, totalPayAmount);

      await axios.put('https://server-gs.vercel.app/add-payment-history', {
        orderId,
        totalAmount,
        amountPaid: totalPayAmount,
        amountDue
      });

      console.log('Payment updated successfully');
    } catch (err) {
      console.error('Failed to update payment:', err);
      setError('Failed to update payment. Please try again.');
    } finally {
      setIsLoading(false);
    }
  };



  useEffect(() => {
    if (orderId  && allSet) {
      const timer = setTimeout(() => {
        updatePaymentInBackend();
      }, 100); // Small delay to avoid too frequent updates

      return () => clearTimeout(timer);
    }
  }, [orderId, allSet, totalPayAmount]);

  return (
    <div className="min-h-screen bg-gray-50 py-10">
      {/* Header Section */}
      <div className="flex flex-col lg:flex-row justify-between items-start pb-8 w-[90%] lg:w-[70%] mx-auto border-b border-gray-300">
        {/* Company Info */}
        <div className="flex items-start space-x-6">
          <img src={logo} alt="Company Logo" className="w-32" />
          <div>
            <h1 className="text-xl lg:text-2xl font-bold text-gray-800">
              My Color Events and Design LLC
            </h1>
            <p className="text-sm lg:text-md text-gray-600 mt-2">
              1565 Monroe Turnpike Monroe, Connecticut 06468 United States
            </p>
            <p className="text-sm lg:text-md text-gray-600">
              info@mycolorevents.com
            </p>
            <p className="text-sm lg:text-md text-gray-600">
              Phone: +1203-548-7769
            </p>
          </div>
        </div>

        {/* Quote Details */}
        <div className="mt-6 lg:mt-0 text-left lg:text-right">
          <h2 className="text-xl lg:text-2xl font-bold text-gray-800">
            Quote: {products?.paymentId || "N/A"}
          </h2>
          <p className="text-sm lg:text-md text-gray-600 mt-2">
            Issue Date:{" "}
            {products?.createdAt
              ? new Date(products?.createdAt).toLocaleString("en-US", {
                  month: "short",
                  day: "numeric",
                  year: "numeric",
                  hour: "numeric",
                  minute: "2-digit",
                  hour12: true,
                })
              : "N/A"}
          </p>
        </div>
      </div>
      <div className=" w-[90%] lg:w-[70%] mx-auto mt-5">
        {/* <button
          onClick={generatePDFTwo}
          className="px-6 py-2 rounded-full bg-indigo-500 text-white  text-sm text-wt-md font-jost"
        >
          Download Payment Receipt
        </button> */}
      </div>
      {/* Payment Section */}
      <div className="flex flex-col lg:flex-row justify-between gap-8 w-[90%] lg:w-[70%] mx-auto mt-5">
        {/* Stripe Payment Form */}
        <div className="w-full lg:w-[60%] bg-white p-8 rounded-xl shadow-lg border border-gray-200">
          <Elements stripe={stripePromise}>
            <StripeForm products={products} payFinalAmount={payFinalAmount} />
          </Elements>
        </div>

        {/* Payment Summary */}
        <div className="w-full lg:w-[40%] bg-white p-8 rounded-xl shadow-lg border border-gray-200">
          <h1 className="text-2xl font-bold text-gray-800 border-b border-gray-300 pb-4">
            Payment Summary
          </h1>
          <div className="space-y-4 mt-6">
            <div className="flex justify-between text-lg text-gray-700">
              <span>Sub Total:</span>
              <span>${calculateAllSetSubTotal(allSet)}</span>
            </div>
            {calculateAllSetDiscount(allSet) !== 0 &&
              calculateAllSetDiscount(allSet) !== "0.00" && (
                <div className="flex justify-between text-lg text-gray-700 border-t pt-4">
                  <span>Discount:</span>
                  <span className="text-red-600">
                    - ${calculateAllSetDiscount(allSet)}
                  </span>
                </div>
              )}
            {calculateAllSetTax(allSet) !== 0 &&
              calculateAllSetTax(allSet) !== "0.00" && (
                <div className="flex justify-between text-lg text-gray-700 border-t pt-4">
                  <span>Tax:</span>
                  <span>${calculateAllSetTax(allSet)}</span>
                </div>
              )}

            <div className="flex justify-between text-lg text-gray-700 border-t pt-4">
              <span>Total:</span>
              <span>${calculateAllSetTotal(allSet)}</span>
            </div>
            {products?.AllProductDiscount &&
              products?.AllProductDiscount !== "0" && (
                <div className="flex justify-between text-lg text-gray-700 border-t pt-4">
                  <span>Discount on Total:</span>
                  <span>
                    {products?.AllProductDiscount}{" "}
                    {products?.AllProductDiscountType}
                  </span>
                </div>
              )}
            {products?.AllProductDiscount &&
              products?.AllProductDiscount !== "0" && (
                <div className="flex justify-between text-lg text-gray-700 border-t pt-4">
                  <span>Final Total:</span>
                  <span>${calculateFinalTotal(allSet, products)}</span>
                </div>
              )}

            <div className="flex justify-between text-lg text-gray-700 border-t pt-4">
              <span>
                Deposit ({products?.advanceDepositValue}{" "}
                {products?.advanceDepositType}):
              </span>
              <span>
                ${" "}
                {calculateDeposit(
                  calculateFinalTotal(allSet, products),
                  products?.advanceDepositValue,
                  products?.advanceDepositType
                )}
              </span>
            </div>
            <div className="flex justify-between text-lg text-gray-700 border-t pt-4">
              <span>Amount Paid:</span>
              <span>$ {totalPayAmount}</span>
            </div>
            <div className="flex justify-between text-lg text-gray-700 border-t pt-4">
              <span>Amount Due:</span>
              <span>$ {amountDue}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EventPayment;
